import { render, staticRenderFns } from "./AddPermissionsCano.vue?vue&type=template&id=5bf3ada2&scoped=true&lang=pug&"
import script from "./AddPermissionsCano.vue?vue&type=script&lang=js&"
export * from "./AddPermissionsCano.vue?vue&type=script&lang=js&"
import style0 from "./AddPermissionsCano.vue?vue&type=style&index=0&id=5bf3ada2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf3ada2",
  null
  
)

export default component.exports